import $ from 'zepto';
// var template = require('../common/template.js');
import template from '../common/template.js';
import U from '../common/util.js';
var ajax = U.ajax;
import msgbox from '../common/msgbox.js';
var logisticsId = 'act_logistics_popbox';
var totalLogisticsLength = 0;
var ajaxFlag = false;
var actid = active_cfg.base.actid;
var tpl = require('../tpl/logistics.tpl');

function logistics(url) {
    if (ajaxFlag) {
        return;
    }
    url = domainList.dyactive2 + '/iface/?action=logininit&keyurl=wap&actid=' + actid;
    ajaxFlag = true;
    ajax(url, function(rs) {
        ajaxFlag = false;
        var result = parseInt(rs.result);
        if (result == 0) {
            var list = rs.data.prizelist || {};
            var listData = [];
            $.each(list, function(i, v) {
                if (v.fafang === 'address') {
                    listData.push(v);
                }
            })
            totalLogisticsLength = listData.length;
            if (listData.length >= 0) {
                var html = template.build(tpl)(listData)
                if (!$('#' + logisticsId).length) {
                    $('body').append(html);
                } else {
                    $('#' + logisticsId).replaceWith(html).show();
                }
                msgbox.show(logisticsId);
            }
        } else if (result == -100) {
            logout();
            login();
        } else {
            msgbox(rs.msg);
        }
    }, function() {
        ajaxFlag = false;
    });
}

$(document).on("click", "#act_logistics_popbox .turn_nav a", function() {
    var $this = $(this);
    if ($this.hasClass('disable')) {
        return;
    }

    var $curGoods = $("#act_logistics_popbox").find("div.cur_logistics");
    var idx = $curGoods.attr('index');
    idx = idx && Number(idx) || 0;

    if ($this.hasClass('prev')) {
        idx--;
        $curGoods.removeClass('cur_logistics').hide();
        $curGoods.prev().addClass('cur_logistics').show();
    } else if ($this.hasClass('next')) {
        idx++;
        $curGoods.removeClass('cur_logistics').hide();
        $curGoods.next().addClass('cur_logistics').show();
    }

    if (idx <= 0) {
        $this.parent().find("a.prev").addClass('disable');
    } else {
        $this.parent().find("a.prev").removeClass('disable');
    }

    if (idx >= totalLogisticsLength - 1) {
        $this.parent().find("a.next").addClass('disable');
    } else {
        $this.parent().find("a.next").removeClass('disable');
    }
}).on('click', '.act_logistics', function() {
    if (!haslogin()) {
        login();
    } else {
        logistics();
    }
});
module.exports = logistics;



// WEBPACK FOOTER //
// ./src/tools/logistics.js